export default __webpack_public_path__ + "static/media/a6.068e2e9c.png";